import { render, staticRenderFns } from "./CompanyFulfillments.vue?vue&type=template&id=f311ce74&"
import script from "./CompanyFulfillments.vue?vue&type=script&lang=js&"
export * from "./CompanyFulfillments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFulfillments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports